export default __webpack_public_path__ + "static/full-e61ff78554b77762c94a5073b55bbf52.png";